import React, { useEffect, useState } from "react";
import "../../doctor/components/allpages.css";
import PropTypes from 'prop-types';
import { visuallyHidden } from '@mui/utils';
import Tooltip from "@mui/material/Tooltip";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Box,
    TablePagination,
  } from "@mui/material";
import TableSortLabel from '@mui/material/TableSortLabel';
import Checkbox from '@mui/material/Checkbox';
import { getCardList, getTransactionAPIData } from "../../../api/cardApi";
import useEncryption from "../../../services/useEncryption";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedId } from "../../../redux/slice/authSlice";
import { TransactionInfoDialog } from "./TransactionInfoDialog";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
      return -1;
  }
  if (b[orderBy] > a[orderBy]) {
      return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
}


function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
          return order;
      }
      return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};

const headCells = [
  {
      id: 'location_name',
      numeric: true,
      disablePadding: true,
      label: 'LocationName',
  },
  {
      id: 'email',
      numeric: true,
      disablePadding: false,
      label: 'Email',
  },
  {
      id: 'type',
      numeric: true,
      disablePadding: false,
      label: 'Type',
  },
  {
      id: 'card_number ',
      numeric: true,
      disablePadding: false,
      label: 'Card Number',
  },
  {
      id: 'card_expiry',
      numeric: true,
      disablePadding: false,
      label: 'Card Expiry',
  },
  {
      id: 'actions',
      numeric: true,
      disablePadding: false,
      label: 'Actions',
  },

];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
      props;
  const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
  };

  return (
      <TableHead>
          <TableRow>
              <TableCell padding="checkbox">
                  <Checkbox
                      color="primary"
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={rowCount > 0 && numSelected === rowCount}
                      onChange={onSelectAllClick}
                      inputProps={{
                          'aria-label': 'select all desserts',
                      }}
                  />
              </TableCell>
              {headCells.map((headCell) => (
                  <TableCell
                      key={headCell.id}
                      // align={headCell.numeric ? 'right' : 'left'}
                      padding={headCell.disablePadding ? 'none' : 'normal'}
                      sortDirection={orderBy === headCell.id ? order : false}
                  >
                      <TableSortLabel
                          active={orderBy === headCell.id}
                          direction={orderBy === headCell.id ? order : 'asc'}
                          onClick={createSortHandler(headCell.id)}
                      >
                          {headCell.label}
                          {orderBy === headCell.id ? (
                              <Box component="span" sx={visuallyHidden}>
                                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                              </Box>
                          ) : null}
                      </TableSortLabel>
                  </TableCell>
              ))}
          </TableRow>
      </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (<></>);
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};



export const CardDetails = ({ search }) => {
 
      const { encryptData, decryptData } = useEncryption();
      const [data, setData] = useState([]);
      const [page, setPage] = useState(0); // Current page (0-based index)
      const [rowsPerPage, setRowsPerPage] = useState(100); // Number of rows per page
      const [totalCount, setTotalCount] = useState(0); // Total number of records
      const [loading, setLoading] = useOutletContext(); // Loading state
      const [selected, setSelected] = React.useState([]);
      const [order, setOrder] = React.useState('desc');
      const [orderBy, setOrderBy] = React.useState('created_at');
      const navigate = useNavigate();
      const dispatch = useDispatch();
      const [ open, setOpen ] = useState(false);
      const [ transId, setTransId ] = useState("");
    
     
      // Fetch paginated data from API
      useEffect(() => {
        const fetchData = async () => {
        setLoading(true); // Set loading state to true before making the request
        try {
            const response = await getCardList(page+1,rowsPerPage,search);
            const decryptedData = decryptData(response?.data?.data);
            setData(decryptedData.payments); // Set the fetched data
            setTotalCount(decryptedData.totalDocuments); 
            setLoading(false);
        } catch (error) {
            console.error("Error fetching paginated data", error);
            setLoading(false);
        }
      };
        dispatch(setSelectedId([]));
        fetchData();
      }, [page, rowsPerPage, search]); // Re-fetch data when page or rows per page changes

      const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(1); // Reset to the first page when rows per page changes
        };
    
      const handleView = (rowData) => {
        // console.log("View data:", rowData);
        // You can navigate to a detail page or open a modal with the row data
      };

      const getTransactionData = async(rowData)=>{
        let id = rowData.providerId._id;
        let encode = encodeURIComponent(encryptData(id));
        setTransId(encode);
        setOpen(true);
        // navigate(`/admin/dashboard/trans-details/${encode}`);
      }

      const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = data.map((row) => row._id);
            setSelected(newSelected);
            dispatch(setSelectedId(['All']));
            return;
        }
        dispatch(setSelectedId([]));
        setSelected([]);
    };

    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };

    const onClose = ()=>{
        setOpen(!open);
    }

    const handleClick = (event, id) => {
      const selectedIndex = selected.indexOf(id);
      let newSelected = [];

      if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
              selected.slice(0, selectedIndex),
              selected.slice(selectedIndex + 1),
          );
      }
      dispatch(setSelectedId(newSelected));
      setSelected(newSelected);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    return(
        <div className='tableDesigned'>
            <Box>
              <Paper>
                <EnhancedTableToolbar numSelected={selected.length} />
                <TableContainer component={Paper}>
                   <Table>
                      <EnhancedTableHead
                          numSelected={selected.length}
                          // order={order}
                          // orderBy={orderBy}
                          onSelectAllClick={handleSelectAllClick}
                          onRequestSort={handleRequestSort}
                          rowCount={totalCount}
                      />
                        <TableBody>
                            {data.map((row, index) => {
                                const isItemSelected = isSelected(row._id);
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row._id}
                                        selected={isItemSelected}
                                        sx={{ cursor: 'pointer' }}
                                    >
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                onClick={(event) => handleClick(event, row._id)}
                                                color="primary"
                                                checked={isItemSelected}
                                                inputProps={{
                                                    'aria-labelledby': labelId,
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell
                                            component="th"
                                            id={labelId}
                                            scope="row"
                                            padding="none"
                                        >
                                           {row.providerId?.organizationName}
                                        </TableCell>
                                        <TableCell>{ row.providerId?.email }</TableCell>
                                        <TableCell>{ row.providerId?.role }</TableCell>
                                        <TableCell>xxxx-xxxx-xxxx-{row.last4}</TableCell>
                                        <TableCell>{ row.exp_month} / {row.exp_year }</TableCell>
                                        <TableCell align="center" className="text-center">
                                            <Tooltip title="View" arrow>
                                            <button onClick={() => getTransactionData(row)} className='actionbuttons'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M20.4908 11.1432C20.8361 11.6696 20.8361 12.3304 20.4908 12.8568C19.4032 14.5146 16.5729 18 11.9999 18C7.4269 18 4.5966 14.5146 3.50898 12.8568C3.16367 12.3304 3.16367 11.6696 3.50898 11.1432C4.5966 9.48535 7.4269 6 11.9999 6C16.5729 6 19.4032 9.48535 20.4908 11.1432Z" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                                <path d="M15 12C15 13.6569 13.6568 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6568 9 15 10.3431 15 12Z" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round" />
                                            </svg></button></Tooltip>
                                        </TableCell>

                                    </TableRow>
                                );
                            })}
                        </TableBody>  
                   </Table>
                </TableContainer>

                {/* Pagination Component */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
                  <TablePagination
                    component="div"
                    count={totalCount} // Use the total number of records from the API
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 25, 50, 100]} // Set available rows per page options
                  />
                </Box>
              </Paper>
              <TransactionInfoDialog open={open} onClose={onClose} id={transId} />
            </Box>
        </div>
    )
}